import { render, staticRenderFns } from "./GeneralDocumentsComponent.vue?vue&type=template&id=a1b12528&"
import script from "./GeneralDocumentsComponent.vue?vue&type=script&lang=js&"
export * from "./GeneralDocumentsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports